<template>
	<div class="layout_warp">
		<Sidebar />
		<main class="right_warp">
			<Headbar />
			<section class="right_bottom_warp m-top10">
				<Tabsbar />
				<div class="right_bottom scroll-view">
					<router-view v-slot="{ Component,route }">
						<keep-alive :include="cacheList" :max="10">
							<component :is="Component" :key="route.name"/>
						</keep-alive>
					</router-view>
				</div>
			</section>
		</main>
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRef,
		ref,
		onMounted
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		useRoute
	} from "vue-router";
	import Sidebar from "./components/sidebar";
	import Headbar from "./components/headbar";
	import Tabsbar from "./components/tabsbar";
	export default defineComponent({
		components: {
			Sidebar,
			Headbar,
			Tabsbar,
		},
		name: "layout",
		setup() {
			const store = useStore();
			const route = useRoute();
			const tabs = computed(() => store.state.tabsList);
			const cacheList= computed(() => store.state.keeptabsList);

			onMounted(() => {});

			return {
				tabs,
				cacheList,
			};
		},
	});
</script>

<style scoped>
	.layout_warp {
		width: 100%;
		height: 100%;
	}

	.right_warp {
		background: #f5f5f5;
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		padding: 15px 15px 15px 90px;
		box-sizing: border-box;
		z-index: 1;
	}

	.right_bottom_warp {
		width: 100%;
		height: calc(100% - 85px);
	}

	.right_bottom {
		width: 100%;
		height: calc(100% - 15px);
		margin-top: 1px;
		overflow: auto;
	}
</style>